import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import useI18n from 'src/hooks/useI18n';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useParams} from 'src/rerouter/index';
import {TitleMedium} from '@spaced-out/ui-design-system/lib/components/Text';

import css from './authenticator-app-reset-approve.css';

import {resetTotpApprove} from 'src/action-creators/authentication';

import {
  selectResetTotpApproveError,
  selectResetTotpApproved,
} from 'src/selectors/authentication';


const AuthenticatorAppResetApprove = (): React.ReactElement<
  React.ComponentProps<'div'>
> => {
  const {t, makeKey} = useLabelTranslation();
  const {token} = useParams();
  const dispatch = useDispatch();
  const apiError = useSelector(selectResetTotpApproveError);
  const apiResponse = useSelector(selectResetTotpApproved);
  const handlePhoneResetApproval = async () => {
    await dispatch(resetTotpApprove(token));
  };

  const errorMessage = apiError?.includes('Already approved by')
    ? t('Already_approved', 'Already approved')
    : t(makeKey(apiError), apiError);

  const successMessage = `${t(
    'The_MFA_reset_is_complete_for',
    'The MFA reset is complete for',
  )} ${apiResponse}`;
  handlePhoneResetApproval();
  return (
    <div className={css.mainContainer}>
      <div className={css.container}>
        {apiError ? (
          <TitleMedium>{errorMessage}</TitleMedium>
        ) : (
          <TitleMedium>{successMessage}</TitleMedium>
        )}
      </div>
    </div>
  );
};

export default AuthenticatorAppResetApprove;
